/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpCircle = createReactComponent("arrow-up-circle", "IconArrowUpCircle", [
  ["path", { d: "M12 17v-14", key: "svg-0" }],
  ["path", { d: "M15 6l-3 -3l-3 3", key: "svg-1" }],
  ["path", { d: "M12 17a2 2 0 1 0 0 4a2 2 0 0 0 0 -4", key: "svg-2" }]
]);

export { IconArrowUpCircle as default };
//# sourceMappingURL=IconArrowUpCircle.js.map
